module.exports = __webpack_public_path__ + "static/headshot-51dd2309c934d1541144b7ed3b640882.png";